<div class="title">
  <mat-icon>factory</mat-icon>
  Industry Sectors
</div>
<div class="description">SELECT THE INDUSTRY SECTORS TO FILTER BY</div>

<div class="options">
  @for (sector of sectors$ | async; track sector) {
    <elements-filter-chip
      icon="factory"
      [caption]="sector"
      [selected]="isSelected(sector)"
      (click)="isSelected(sector) ? removeProduct(sector) : addProduct(sector)"
      [suffixIcon]="isSelected(sector) ? 'close' : undefined"
      >
    </elements-filter-chip>
  }
  <br />

  @if (selectedSector()) {
    <div class="description">
      SELECT THE {{ selectedSector() }} INDUSTRY SUB-SECTORS TO FILTER BY (* OPTIONAL)
    </div>
  }
  <br />
  @for (subSector of filterSubSectors((subSectors$ | async), selectedSector()); track subSector) {
    <elements-filter-chip
      icon="factory"
      [caption]="subSector"
      [selected]="isSelected(subSector)"
      (click)="isSelected(subSector) ? removeProduct(subSector) : addProduct(subSector)"
      [suffixIcon]="isSelected(subSector) ? 'close' : undefined"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
